import axios from 'axios';
import store from '@/store';

// Flag to track token expiration handling
let tokenExpirationHandled = false;

const instance = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true,
});

instance.interceptors.request.use(
  async (config) => {
    const bearerToken = localStorage.getItem('bearer_token');
    if (bearerToken) {
      config.headers['Authorization'] = `Bearer ${bearerToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if it's an authentication error (401)
    if (error.response && error.response.status === 401) {
      // Get the baseURL and url from the error config
      let baseURL = error.config.baseURL ?? '';
      let url = error.config.url ?? '';
      let fullUrl = baseURL + url;

      // Only handle 401s from our API and prevent duplicate handling
      if (fullUrl.includes(import.meta.env.VITE_BASE_URL) && !tokenExpirationHandled) {
        tokenExpirationHandled = true;
        
        try {
          // Display a warning message to the user
          if (store && store.dispatch) {
            store.dispatch('handleExpiredSession');
          }
        } catch (error) {
          setTimeout(() => { window.location.href = 'https://vlifemedia.com'; }, 2000);
        }
      }
    }
    return Promise.reject(error);
  }
);

// Reset the token expiration flag when the page is reloaded or focused
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    tokenExpirationHandled = false;
  });
  
  window.addEventListener('focus', () => {
    // Check if the token exists
    const bearerToken = localStorage.getItem('bearer_token');
    if (!bearerToken && store && store.state && store.state.isAuthenticated) {
      try {
        // Display a warning message to the user
        if (store && store.dispatch) {
          store.dispatch('handleExpiredSession');
        }
      } catch (error) {
        setTimeout(() => { window.location.href = 'https://vlifemedia.com'; }, 2000);
      }
    } else {
      // Reset the flag if the token exists
      tokenExpirationHandled = false;
    }
  });
}

instance.create = function (config) {
  // Create a new Axios instance with the provided config
  const newAxiosInstance = axios.create(config);
  return newAxiosInstance;
};

export default instance;
